/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";

export type CreatePromptTemplateResult = {
  /**
   * A prompt template
   */
  template: PromptTemplate;
};

/** @internal */
export const CreatePromptTemplateResult$inboundSchema: z.ZodMiniType<
  CreatePromptTemplateResult,
  unknown
> = z.object({
  template: PromptTemplate$inboundSchema,
});

export function createPromptTemplateResultFromJSON(
  jsonString: string,
): SafeParseResult<CreatePromptTemplateResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePromptTemplateResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePromptTemplateResult' from JSON`,
  );
}
